import {Component, EventEmitter, inject, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectContainer, ProjectContainerCreate} from '../../../../shared/models/project-container';
import {NZ_DRAWER_DATA, NzDrawerRef} from 'ng-zorro-antd/drawer';
import {ProjectUtilsService} from '../../services/project-utils.service';
import {
  ContainerTypes,
  PostResponse,
  Service,
  ServiceOrderWithTemplateParams,
  TableColumn,
  ToastConfig
} from '@app/shared';
import {compareById, ProjectService, ScreenService, StServiceService} from '@app/core';
import {lastValueFrom} from 'rxjs';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-container-create-drawer',
  standalone: false,

  templateUrl: './container-create-drawer.component.html',
  styleUrl: './container-create-drawer.component.less'
})
export class ContainerCreateDrawerComponent implements OnInit {

  nzData: {
    containers?: ProjectContainer[],
    isCreateContainer: boolean,
    containerTypes: ContainerTypes[]
  } = inject(NZ_DRAWER_DATA);

  @Output() updateContainers = new EventEmitter<void>();
  @Output() updateSO = new EventEmitter<void>();

  loading: boolean = true;

  @ViewChild('notificationTmpl') notificationTmpl: any;
  notRef: any;
  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Contenedor creado!',
    showUndo: false
  };
  visitedTip = false;
  step: number = 1;
  creatingContainer = 0;
  selectedService: Service | undefined;
  selectedContainerType: ContainerTypes | undefined;
  containersReferences: string = '';
  duplicateReferences: string[] = [];
  /** Variables de tabla **/
  columns: TableColumn[] = [
    {
      name: '',
      width: '65',
      checkbox: true,
      align: 'center'
    },
    {
      name: 'Nº OS',
      width: '224',
      align: 'left',
    },
    {
      name: 'Ref. Contenedor',
      align: 'left'
    },
  ];
  tabeData: { serviceOrderNumber: string, containerReference: string, isActive: boolean }[] = [];
  isIndeterminate: boolean = false;
  isAllSelected: boolean = false;
  selectedDataReferences = new Set<string>();
  protected readonly compareById = compareById;

  constructor(
    private drawerRef: NzDrawerRef<string>,
    public ps: ProjectUtilsService,
    public screenService: ScreenService,
    private projectService: ProjectService,
    private stServiceService: StServiceService,
    private notificationService: NzNotificationService,
    public authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.step = this.nzData.isCreateContainer ? 1 : 2;
    this.selectedContainerType = this.nzData.containerTypes.length > 0 ? this.nzData.containerTypes[0] : undefined;

    if (this.ps.selectedProject && this.ps.selectedProject.services && this.ps.selectedProject.services.length > 0) {
      this.selectedService = this.ps.selectedProject.services[0];
    }

    if (!this.nzData.isCreateContainer) {
      this.generateDataFromString();
    }

    this.loading = false;
  }

  close() {
    this.drawerRef.close();
  }

  /** Logica de seleccion de Equipos **/
  //region Seleccion
  // Alternamiento individual - CORREGIDO
  toggleSelectData(reference: string): void {
    const newSet = new Set(this.selectedDataReferences);

    if (newSet.has(reference)) {
      newSet.delete(reference);
    } else {
      newSet.add(reference);
    }

    this.selectedDataReferences = newSet;
    this.updateSelectionState(); // Actualizar estados después de cambiar
  }

  // Alternamiento total
  toggleSelectAllData(): void {
    const shouldSelectAll = !this.isAllSelected;
    const newSet = new Set<string>();

    if (shouldSelectAll) {
      this.tabeData.forEach(item => {
        if (item.isActive) { // Solo seleccionar elementos activos
          newSet.add(item.containerReference);
        }
      });
    }

    this.selectedDataReferences = newSet;
    this.updateSelectionState(); // Actualizar estados después de cambiar
  }

  // Actualizar estados de selección
  updateSelectionState(): void {
    const activeItems = this.tabeData.filter(item => item.isActive);
    const activeCount = activeItems.length;
    const selectedCount = activeItems.filter(item =>
      this.selectedDataReferences.has(item.containerReference)
    ).length;

    this.isAllSelected = activeCount > 0 && selectedCount === activeCount;
    this.isIndeterminate = selectedCount > 0 && selectedCount < activeCount;
  }

  //endregion

  generateDataFromString() {
    let lines;

    if (this.nzData.isCreateContainer) {
      // Si el string está vacío o solo contiene espacios/saltos de línea
      if (this.containersReferences.trim() === '') {
        this.tabeData = [];
        this.selectedDataReferences.clear();
        this.isAllSelected = false;
        this.duplicateReferences = [];
        return;
      }

      // Dividir por saltos de línea
      lines = this.containersReferences.split('\n');
    } else {

      // Si se abre como solo crear Ordenes se toman las referencias de los contenedores ya existentes
      lines = this.nzData.containers!.map(container => container.containerRef);
    }

    // Procesar cada línea: hacer trim y filtrar vacías
    const processedLines = lines
      .map(line => line.trim())              // Eliminar espacios al inicio/final
      .filter(line => line !== '')           // Filtrar líneas vacías
      .filter((line, index, self) =>         // Eliminar duplicados internos
        self.indexOf(line) === index
      );

    // Verificar duplicados con contenedores existentes
    this.checkDuplicateReferences(processedLines);

    // Filtrar duplicados de la lista final
    const finalLines = processedLines.filter(line => !this.duplicateReferences.includes(line));

    // Limpiar selecciones anteriores y seleccionar todos los nuevos (sin duplicados)
    this.selectedDataReferences = new Set(finalLines);
    this.isAllSelected = finalLines.length > 0;

    // Crear lista de objetos sin duplicados ni líneas vacías
    this.tabeData = finalLines.map((line, index) => ({
      serviceOrderNumber: String(index),
      containerReference: line,
      isActive: true,
    }));
  }

  /**
   * Verifica si hay referencias duplicadas con contenedores existentes
   */
  private checkDuplicateReferences(references: string[]): void {
    if (!this.ps.selectedProject?.projectContainers || this.ps.selectedProject?.projectContainers.length === 0) {
      this.duplicateReferences = [];
      return;
    }

    const existingReferences = (this.ps.selectedProject?.projectContainers || []).map(container => container.containerRef);
    this.duplicateReferences = references.filter(reference =>
      existingReferences.includes(reference)
    );
  }

  changeToStepTwo() {
    this.generateDataFromString();
    this.step = 2;
  }

  stepOneValid(): boolean {
    return !!this.containersReferences && !!this.selectedContainerType && this.selectedDataReferences.size > 0;
  }

  async createContainer(onlyContainers: boolean) {
    this.creatingContainer = onlyContainers ? 2 : 1;

    this.generateDataFromString();

    try {
      let containerRsp: PostResponse;
      if (this.nzData.isCreateContainer) {
        const params: ProjectContainerCreate = {
          containerRefs: Array.from(this.selectedDataReferences),
          containerTypeId: this.selectedContainerType!.id,
          projectId: this.ps.selectedProject!.id,
        };

        containerRsp = await lastValueFrom(this.projectService.createProjectContainer(params));

        this.ps.selectedProject!.projectContainers = [...this.ps.selectedProject!.projectContainers || [], ...containerRsp.data];
        this.updateContainers.emit();
      }

      this.toastConfig.content = 'Entidades creadas.';
      this.toastConfig.icon = 'check_circle';
      this.toastConfig.iconColor = '#6CDA75';
      this.showNotification();

    } catch (e: any) {
      this.toastConfig.content = 'Error al tratar de crear las entidades.';
      this.toastConfig.msg = e.error.message;
      this.toastConfig.icon = 'dangerous';
      this.toastConfig.iconColor = '#CB2A2F';
      this.showNotification();
    }

  }

  showNotification(): void {
    this.notRef = this.notificationService
      .create("blank", '', this.notificationTmpl, {nzPlacement: "bottomRight"});
    this.close();
  }
}
